import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'
import { DeviceNameConflictError, isNameConflict } from '../deviceErrors'

interface RegisterDeviceInput {
  name: string
  branchId: string
}

interface RegisterDeviceResult {
  pairingCode: string
  expiresAt: Date
}

async function registerDevice(input: RegisterDeviceInput): Promise<RegisterDeviceResult> {
  const { data, error } = await supabase
    .rpc('register_device', { p_name: input.name, p_branch_id: input.branchId })
  if (error) {
    if (isNameConflict(error)) throw new DeviceNameConflictError()
    reportUnexpectedError(error)
    throw error
  }
  return {
    pairingCode: data.pairing_code as string,
    expiresAt: new Date(data.expires_at as string),
  }
}

export function useRegisterDevice() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: registerDevice,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['devices'] }),
  })
}
